import type {ComponentStageData, ComponentStageHeuristicDefinition} from '../../types'
import type {StructureEntryItem} from '../../conversionDal/types'
import {getParent, isBackgroundComponent} from '../common'

const moveComponentToBackgroundOfParent = ({conversionDal, componentPointer}: ComponentStageData) => {
    const parentPointer = getParent(conversionDal, componentPointer)

    if (parentPointer) {
        conversionDal.modify(parentPointer, (currentValue: StructureEntryItem) => ({
            ...currentValue,
            components: currentValue.components?.filter(compId => compId !== componentPointer.id),
            backgroundComponents: (currentValue.backgroundComponents ?? []).concat([componentPointer.id])
        }))
    }
}

export const backgroundComponentsHeuristics: ComponentStageHeuristicDefinition[] = [
    {
        predicate: isBackgroundComponent,
        apply: moveComponentToBackgroundOfParent,
        heuristicCode: 'MOVE BACKGROUND COMPONENTS'
    }
]
